import { apiRequest } from './api';

// Auth storage keys
export const AUTH_TOKEN_KEY = 'ai_escape_game_token';
export const AUTH_USER_KEY = 'ai_escape_game_user';
export const AUTH_REFRESH_TOKEN_KEY = 'ai_escape_game_refresh_token';

// Get token from localStorage
export const getStoredToken = () => {
  return localStorage.getItem(AUTH_TOKEN_KEY);
};

// Store token in localStorage
export const storeToken = (token, user) => {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
  if (user?.refresh_token) {
    localStorage.setItem(AUTH_REFRESH_TOKEN_KEY, user.refresh_token);
  }
};

// Store game session data
export const storeGameSession = (gameSession) => {
  localStorage.setItem('ai_escape_game_session', JSON.stringify(gameSession));
};

// Get game session data
export const getStoredGameSession = () => {
  const sessionData = localStorage.getItem('ai_escape_game_session');
  return sessionData ? JSON.parse(sessionData) : null;
};

// Clear game session data
export const clearGameSession = () => {
  localStorage.removeItem('ai_escape_game_session');
};

// Clear stored token
export const clearStoredToken = () => {
  localStorage.removeItem(AUTH_TOKEN_KEY);
  localStorage.removeItem(AUTH_USER_KEY);
  localStorage.removeItem(AUTH_REFRESH_TOKEN_KEY);
  clearGameSession();
};

// Get stored user data
export const getStoredUser = () => {
  const userData = localStorage.getItem(AUTH_USER_KEY);
  return userData ? JSON.parse(userData) : null;
};

export const getStoredRefreshToken = () => {
  return localStorage.getItem(AUTH_REFRESH_TOKEN_KEY);
};

// Validate token with backend
export const validateToken = async (token) => {
  try {
    const res = await apiRequest('/auth/verify', {
      headers: { Authorization: `Bearer ${token}` }
    });
    return res.ok;
  } catch (err) {
    console.error('Token validation error:', err);
    return false;
  }
};
